import { autocompleteActionPrefix, IAutocompleteSearchPayload } from 'shared/components/autocomplete/EntityAutocompleteWithSearch/store/actions';
import { IDealRequest } from 'store/entities/configuration/configurationModel';
import { createSingleAction } from 'store/utils';

interface IDealSearchRequest extends IAutocompleteSearchPayload {
    request: IDealRequest;
}
const searchDealAction = `${autocompleteActionPrefix}/DEAL`;
export const autocompleteSearchDeal = createSingleAction<IDealSearchRequest, typeof searchDealAction>(searchDealAction);
